import { render, staticRenderFns } from "./ImportValidationModalWarningBox.vue?vue&type=template&id=c8449956&"
import script from "./ImportValidationModalWarningBox.vue?vue&type=script&lang=js&"
export * from "./ImportValidationModalWarningBox.vue?vue&type=script&lang=js&"
import style0 from "./ImportValidationModalWarningBox.vue?vue&type=style&index=0&id=c8449956&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports